<template>
  <v-container class="cmp-distribution-supplier-order-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedSupplierOrderDetails &&
              selectedSupplierOrderDetails.supplier_order &&
              selectedSupplierOrderDetails.supplier_order.supplier_name
            "
          >
            <span
              v-if="
                selectedSupplierOrderDetails &&
                selectedSupplierOrderDetails.supplier_order
              "
              >{{
                selectedSupplierOrderDetails.supplier_order.supplier_name ||
                "Supplier Name"
              }}</span
            >
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div
                v-if="
                  selectedSupplierOrderDetails &&
                  selectedSupplierOrderDetails.supplier_order
                "
              >
                {{
                  selectedSupplierOrderDetails.supplier_order.supplier_name ||
                  "Supplier Name"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <glayout
        :tabs="supplierOrderSidewindowTab"
        :menu="menuOptions"
        :options="[{ value: 'documents', text: $t('documents_string') }]"
        :loading="
          selectedSupplierOrderDetails && selectedSupplierOrderDetails.loading
        "
        @optionClicked="onTabOptionClicked"
      >
        <gtab id="overview">
          <grow>
            <gcol>
              <gbox
                v-if="selectedSupplierOrderDetails.supplier_order"
                :title="$t('supplier_order')"
                :h="setUpBoxHeight"
              >
                <SupplierOrderSetup
                  :selectedSupplierOrderDetails="selectedSupplierOrderDetails"
                  @changed="onUpdated"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                v-if="selectedSupplierOrderDetails.related_documents"
                :title="$t('related_documents')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedSupplierOrderDetails &&
                      selectedSupplierOrderDetails.related_documents &&
                      selectedSupplierOrderDetails.related_documents.length,
                    rowHeight: 32,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                    max: 10,
                  })
                "
              >
                <DBoxFiles
                  :files="selectedSupplierOrderDetails.related_documents"
                  :externalId="`${this.supplier_order_id}`"
                  :externalTable="'supplier_orders'"
                />
              </gbox>
              <gbox :title="$dft.capHead($t('info'))">
                <SupplyOrderInfo
                  :selectedSupplierOrderDetails="selectedSupplierOrderDetails"
                  @changed="onUpdated"
                />
              </gbox>

              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :id="'notes'"
                  :value="
                    selectedSupplierOrderDetails.supplier_order.notes || ''
                  "
                  @blur="
                    (e) =>
                      onUpdated({
                        name: 'notes',
                        value: e.target.value,
                      })
                  "
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                v-if="supply_order_type == 1"
                :title="$dft.capHead($t('orderlines'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedSupplierOrderDetails &&
                      selectedSupplierOrderDetails.s_orderlines &&
                      selectedSupplierOrderDetails.s_orderlines.length,
                    rowHeight: 32,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    min: 0,
                    max: 10,
                  })
                "
              >
                <SOrderLines
                  :selectedSupplierOrderDetails="selectedSupplierOrderDetails"
                  @change="onSOrderLinesUpdate"
                  @add="onSOrderLinesInsert"
                  @delete="onSOrderLinesDelete"
                />
              </gbox>
              <!-- v-if="selectedSupplierOrderDetails.orderlines" -->
              <gbox
                v-else
                :title="$dft.capHead($t('orderlines'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedSupplierOrderDetails &&
                      selectedSupplierOrderDetails.orderlines &&
                      selectedSupplierOrderDetails.orderlines.length,
                    rowHeight: 52,
                    offset: NTOffsets.WithHeaderDBoxBottom + 26,
                    min: 1,
                    max: 10,
                  })
                "
              >
                <OrderLines
                  @change="onSOrderLinesUpdate"
                  :selectedSupplierOrderDetails="selectedSupplierOrderDetails"
                  @delete="onSOrderLinesDelete"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <BottomButton
                @menuClick="onTabOptionClicked"
                :buttonList="menuOptions"
              />
            </gcol>
          </grow>
        </gtab>
        <gtab v-if="supply_order_type == 1" id="backorder">
          <grow>
            <gcol>
              <gbox
                :title="$dft.capHead($t('backorders'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedSupplierOrderDetails &&
                      selectedSupplierOrderDetails.backorders &&
                      selectedSupplierOrderDetails.backorders.length,
                    rowHeight: 32,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                    max: 10,
                  })
                "
              >
                <BackOrderTable
                  @change="onSOrderLinesUpdate"
                  :selectedSupplierOrderDetails="selectedSupplierOrderDetails"
                  @delete="onSOrderLinesDelete"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$dft.capHead($t('orderlines'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedSupplierOrderDetails &&
                      selectedSupplierOrderDetails.orderlines &&
                      selectedSupplierOrderDetails.orderlines.length,
                    //rowHeight: 32,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                   
                    max: 10,
                  })
                "
              >
              <!-- :h="
                  boxHeightNamed({
                    rowCount:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.related_genres &&
                      selectedReleaseDetails.related_genres.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    max: 15,
                  })
                " -->
                <BackorderOrderLines
                  @change="onSOrderLinesUpdate"
                  :selectedSupplierOrderDetails="selectedSupplierOrderDetails"
                  @delete="onSOrderLinesDelete"
                  @add="onBOrderLinesInsert"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab v-if="supply_order_type == 1" id="delivery">
          <grow>
            <gcol>
              <gbox
                :title="$dft.capHead($t('orderlines'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedSupplierOrderDetails &&
                      selectedSupplierOrderDetails.deliveries &&
                      selectedSupplierOrderDetails.deliveries.length,
                    rowHeight: 32,
                    offset: NTOffsets.WithHeader,
                    min: 1,
                    max: 10,
                  })
                "
              >
              <!-- :h="
                  boxHeightNamed({
                    rowCount:
                      selectedReleaseDetails &&
                      selectedReleaseDetails.related_licences &&
                      selectedReleaseDetails.related_licences.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                " -->
                <DeliveryTable
                  :selectedSupplierOrderDetails="selectedSupplierOrderDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
  </v-container>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapGetterObject, mapActionObject } from "../../../../store/global";

import { checkTabListPermission } from "../../../../router/guard";

import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import DBoxTextarea from "@/dt-plugins/dbox-textarea/dbox-textarea";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";

import {
  createModalMixin,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { distributionSupplierOrderActions } from "../../store/supplier_orders/actions";
import { distributionSupplierOrderGetters } from "../../store/supplier_orders/getters";

//componenets

import SupplierOrderSetup from "./supplier-order-setup.vue";
import SOrderLines from "./s-orderlines.vue";
import OrderLines from "./orderlines.vue";
import SupplyOrderInfo from "./supply-order-info.vue";
import { SupplierOrdersService } from "../../services/supplier.order.service";
import { sendMailHref } from "../../../../utility";
import {
  costListLDTRoutes,
  invoiceListLDTRoutes,
} from "../../../accounting/router/routes";
import BottomButton from "./bottom-button.vue";
import BackorderOrderLines from "./backorder-orderlines.vue";
import BackOrderTable from "./backorder-table.vue";
import DeliveryTable from "./delivery.vue";
export const moduleRoute = "distribution";
export const submenuRoute = "statement_list";
import FileDownload from "js-file-download";
export default {
  components: {
    ModalContainer,

    DBoxTextarea,
    DBoxFiles,

    SupplierOrderSetup,
    SOrderLines,
    SupplyOrderInfo,
    OrderLines,
    BottomButton,
    BackorderOrderLines,
    BackOrderTable,
    DeliveryTable,
  },
  data() {
    return {};
  },
  mixins: [createModalMixin("licenceIncomeForm"), createDTGridHost()],
  computed: {
    ...mapGetterObject(storeNS, distributionSupplierOrderGetters),

    supplierOrderSidewindowTab: function () {
      let tab = [
        {
          route: "overview",
          value: this.$t("overview"),
        },
      ];

      if (this.supply_order_type == 1) {
        tab = [
          ...tab,
          {
            route: "backorder",
            value: this.$t("backorder"),
          },
          {
            route: "delivery",
            value: this.$t("delivery"),
          },
        ];
      }

      return checkTabListPermission(moduleRoute, submenuRoute, [...tab]);
    },

    supplier_order_id: function () {
      return this.$route.params.supplier_order_id;
    },

    setUpBoxHeight: function () {
      if (this.selectedSupplierOrderDetails.s_orderlines) return 355;
      else return 260;
    },

    selectedSupplierOrderDetails: function () {
      const distributionSupplierOrderDetails =
        (this.distributionSupplierOrderDetails || {})[this.supplier_order_id] ||
        {};
      const supplier_order =
        distributionSupplierOrderDetails.supplier_order || {};
      const so = distributionSupplierOrderDetails.so || {};
      const supply_order_types =
        distributionSupplierOrderDetails.supply_order_types || [];
      //const related_documents = distributionSupplierOrderDetails.related_documents||[];
      //   const contact   =distributionSupplierOrderDetails.contact||{};

      console.log(
        "this.distributionSupplierOrderDetails:::",
        distributionSupplierOrderDetails
      );

      return {
        ...distributionSupplierOrderDetails,
        supplier_order,
        so,
        supply_order_types,
      };
    },
    supply_order_type: function () {
      return (
        this.selectedSupplierOrderDetails?.supplier_order?.supply_order_type ||
        ""
      );
    },

    menuOptions: function () {
      //this.selectedSupplierOrderDetails.s_orderlines
      if (this.supply_order_type == 1) {
        if (this.selectedSupplierOrderDetails.so.accounted_flag == 1) {
          if (this.selectedSupplierOrderDetails.has_open_paper_part_qty) {
            return [
              {
                text: this.$t("shipping_info"),
                value: "shipping_info",
              },
              {
                text: this.$t("documents"),
                value: "documents",
              },
              {
                text: this.$t("stock_in_info"),
                value: "stock_in_info",
              },
              {
                text: this.$t("account_costs"),
                value: "account_costs",
              },
              {
                text: this.$t("reopen"),
                value: "reopen",
              },
            ];
          } else {
            return [
              {
                text: this.$t("shipping_info"),
                value: "shipping_info",
              },
              {
                text: this.$t("documents"),
                value: "documents",
              },
              {
                text: this.$t("stock_in_info"),
                value: "stock_in_info",
              },
              {
                text: this.selectedSupplierOrderDetails.lbl.label,
                value: "invoice",
              },
              {
                text: this.$t("reopen"),
                value: "reopen",
              },
            ];
          }
        } else {
          return [
            {
              text: this.$t("get_label_accounts"),
              value: "get_label_accounts",
            },
            {
              text: this.$t("shipping_info"),
              value: "shipping_info",
            },
            {
              text: this.$t("documents"),
              value: "documents",
            },
            {
              text: this.$t("stock_in_info"),
              value: "stock_in_info",
            },
            {
              text: this.$t("account_delivery"),
              value: "account_delivery",
            },
            {
              text: this.$t("finish_order"),
              value: "finish_order",
            },
            {
              text: this.$t("Delete"),
              value: "delete",
              error: true,
            },
          ];
        }
      } else {
        if (this.selectedSupplierOrderDetails.so.accounted_flag == 1) {
          return [
            {
              text: this.$t("reception_email"),
              value: "reception_email",
            },

            {
              text: this.$t("documents"),
              value: "documents",
            },

            {
              text: this.$t("email_order"),
              value: "email_order",
            },

            {
              text: this.$t("account_costs"),
              value: "account_costs",
            },

            {
              text: this.$t("reopen"),
              value: "reopen",
            },
          ];
        } 
        else {
          return [
            {
              text: this.$t("email_order"),
              value: "email_order",
            },
            {
              text: this.$t("remove_all_lines"),
              value: "remove_all_lines",
            },
            {
              text: this.$t("import_excel"),
              value: "import_excel",
            },
            {
              text: this.$t("export_excel"),
              value: "export_excel",
            },
            {
              text: this.$t("account_delivery"),
              value: "account_delivery",
            },

            {
              text: this.$t("documents"),
              value: "documents",
            },
            {
              text: this.$t("Delete"),
              value: "delete",
              error: true,
            },
          ];
        }
      }
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionSupplierOrderActions),

    onTabOptionClicked(value) {
      switch (value) {
        case "get_label_accounts": {
          this.onLabelAccountClick();
          break;
        }
        case "shipping_info": {
          this.onShippingInfoClick();
          break;
        }
        case "documents": {
          openModalRoute2(this, "dtTemplateList", {
            external_id: this.supplier_order_id,
          });
          break;
        }
        case "stock_in_info": {
          this.onStockInfoClick();
          break;
        }
        case "account_delivery": {
          if (this.selectedSupplierOrderDetails.s_orderlines) {
            this.onAccountDeliveryClick();
          } else {
            this.onFinishOrder();
          }

          break;
        }
        case "finish_order": {
          this.onFinishOrder();
          break;
        }
        case "delete": {
          this.onDelete();
          break;
        }
        case "email_order": {
          this.onEmailOrderClick();
          break;
        }
        case "reopen": {
          this.onReopenClick();
          break;
        }
        case "reception_email": {
          this.onReceptionMailClick();
          break;
        }
        case "account_costs": {
          if (this.selectedSupplierOrderDetails.s_orderlines) {
            this.onCostAmountModal();
          } else {
            this.onExchangeRate();
          }

          break;
        }
        case "invoice": {
          this.onInvoiceClick();
        }
        case "remove_all_lines": {
          this.onRemoveAllLines();

          break;
        }
        case "import_excel": {
          this.onImportExcel();

          break;
        }
        case "export_excel": {
          this.onExportExcel();

          break;
        }

        default: {
        }
      }
    },

    onImportExcel: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "import_excel",
          supplier_order_id: this.supplier_order_id,
        },
      });
    },
    onExportExcel: function () {
      SupplierOrdersService.exportExcelSo(this.supplier_order_id).then(res => {
        FileDownload(res.data, `supplier_order_${this.supplier_order_id}.xlsx`);
      });
    },

    onRemoveAllLines: async function () {
      await this[
        ActionTypes.DistributionSupplierOrderOrderLines.DELETE.MULTIPLE
      ]({ supplier_order_id: this.supplier_order_id });
    },

    onInvoiceClick: async function () {
      const confirmationResult = await ConfirmationService.createP({
        body: this.$t("msg_account_costs_invoiced"),
        results: [
          createConfirmResult({
            value: "ok",
            text: "OK",
            classes: ["v1 s7"],
          }),
        ],
      });

      const { invoice_id } = this.selectedSupplierOrderDetails.lbl;

      if (this.selectedSupplierOrderDetails.lbl.cost_flag) {
        this.$router.push({
          name: costListLDTRoutes.names.tab,
          params: {
            invoice_id: invoice_id,
            tab: "overview",
          },
        });
      } else {
        this.$router.push({
          name: invoiceListLDTRoutes.names.tab,
          params: {
            invoice_id: invoice_id,
            tab: "overview",
          },
        });
      }
    },

    onCostAmountModal: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "cost_amount_modal",
          supplier_order_id: this.supplier_order_id,
        },
      });
    },
    onExchangeRate: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "exchange_rate_modal",
          supplier_order_id: this.supplier_order_id,
        },
      });
    },

    onLabelAccountClick: async function () {
      await this[
        ActionTypes.DistributionSupplierOrderSOrderLines.INSERT.MULTIPLE
      ]({ supplier_order_id: this.supplier_order_id });
    },

    onReopenClick: async function () {
      if (this.selectedSupplierOrderDetails.s_orderlines) {
        SupplierOrdersService.reopenOrderPost(this.supplier_order_id);
      } else {
        const confirmationResult = await ConfirmationService.createP({
          body: this.$t("reopen_order_msg"),
          results: [
            createConfirmResult({
              value: "no",
              text: "No",
            }),
            createConfirmResult({
              value: "yes",
              text: "Yes",
              classes: ["v1"],
            }),
          ],
        });

        if (confirmationResult == "yes") {
          SupplierOrdersService.reopenOrderGet(this.supplier_order_id);
        }
      }

      this[ActionTypes.DistributionSupplierOrderDetails.FETCH.SINGLE]({
        flag: true,
        order: this.selectedSupplierOrderDetails.supplier_order,
        reload: true,
      });
    },

    onReceptionMailClick: async function () {
      const res = await SupplierOrdersService.poReceptionEmailData(
        this.supplier_order_id
      );

      const { email_subject, email_address, email_body } = res.data;

      sendMailHref({
        subject: email_subject,
        body: email_body,
        mails: [email_address],
      });

      console.log(res);
    },

    // onDocumentsClick: function () {
    //   this.$router.push({
    //     ...this.$route,
    //     query: {
    //       modal: "document_modal",
    //       supplier_order_id: this.supplier_order_id,
    //     },
    //   });
    // },

    onFinishOrder: async function () {
      let msg = this.selectedSupplierOrderDetails.so_account
        ? "multi_product_order_warning"
        : "single_product_order_warning";

      if (
        this.selectedSupplierOrderDetails?.so_account?.account_name ||
        this.selectedSupplierOrderDetails?.so_product?.catalog_no
      ) {
        let header = "";

        let action = "";

        if (this.selectedSupplierOrderDetails.s_orderlines) {
          header = this.$t("finish_order");
          action = "finish_order";
        } else {
          header = this.$t("accounted_date");
          action = "account_order_multi_product";
        }

        this.$router.push({
          ...this.$route,
          query: {
            modal: "finish_order_modal",
            supplier_order_id: this.supplier_order_id,
            header: header,
            action: action,
          },
        });
      } else {
        const confirmationResult = await ConfirmationService.createP({
          body: this.$t(msg),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });
      }
    },

    onAccountDeliveryClick: async function () {
      let msg = this.selectedSupplierOrderDetails.so_account
        ? "multi_product_order_warning"
        : "single_product_order_warning";

      if (
        this.selectedSupplierOrderDetails?.so_account?.account_name ||
        this.selectedSupplierOrderDetails?.so_product?.catalog_no
      ) {
        this.$router.push({
          ...this.$route,
          query: {
            modal: "shipping_date_modal",
            supplier_order_id: this.supplier_order_id,
          },
        });
      } else {
        const confirmationResult = await ConfirmationService.createP({
          body: this.$t(msg),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });
      }
    },
    onDelete: function () {
      this.$emit("delete", { supplier_order_id: this.supplier_order_id });
    },

    onEmailOrderClick: async function () {
      const res = await SupplierOrdersService.infoMailMultiProduct(
        this.supplier_order_id
      );

      console.log(res, "::::::::::::::::::::");

      const { subject, body } = res.data.mail;

      const properBody = body.replace(/%0A/gi, "\n").replace(/%09/gi, "   ");

      console.log(properBody);

      sendMailHref({ subject, body: properBody, mails: [] });

      // Purchase Return #183 %0A%0A
      // Delivery Address
      // %0A
      // Bandcamp - Delivery Address is not specified.
      // %0A%0A
      // Ordered Items

      // %0A%0A
      // 20 %09 DETREC 002 %09 2.10 %0A
      // 30 %09 DETREC 002 LP %09 2.10 %0A
      // 40 %09 DETREC 003 %09 2.20
    },

    onShippingInfoClick: async function () {
      const res = await SupplierOrdersService.shippingInfoMailSingle(
        this.supplier_order_id
      );

      const { subject, body } = res.data.mail;
      sendMailHref({ subject, body, mails: [] });

      console.log(res, ":::::::::::::");
    },

    onStockInfoClick: async function () {
      const res = await SupplierOrdersService.stockInInfoEmail(
        this.supplier_order_id
      );

      const body = res.data.body_html;

      const emails = res.data.stock_info.emails;

      const so = res.data.stock_info.so;

      //Stock In info DETREC 001-RED, Order# 169

      const subject = `${this.$t("stock_in_info")} ${so.catalog_no}, Order# ${
        so.supplier_order_id
      }`;

      sendMailHref({ subject, body, emails });

      //console.log("::::::::::::::::::::::",res)
    },

    onUpdated: function (payload) {
      this[ActionTypes.DistributionSupplierOrderDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedSupplierOrderDetails,
      });
    },
    onSOrderLinesUpdate: function (payload) {
      this[ActionTypes.DistributionSupplierOrderSOrderLines.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedSupplierOrderDetails,
      });
    },

    onSOrderLinesInsert: function () {
      this[ActionTypes.DistributionSupplierOrderSOrderLines.INSERT.SINGLE]({
        ...this.selectedSupplierOrderDetails,
      });
    },

    onSOrderLinesDelete: function (payload) {
      const { item, objKey } = payload;
      this[ActionTypes.DistributionSupplierOrderSOrderLines.DELETE.SINGLE]({
        supplierOrderItem: item,
        item: this.selectedSupplierOrderDetails,
        objKey,
      });
    },
    onBOrderLinesInsert: function () {
      this[ActionTypes.DistributionSupplierOrderBOrderLines.INSERT.SINGLE]({
        ...this.selectedSupplierOrderDetails,
      });
    },

    // onOrderLinesUpdate:function(payload){
    //   this[ActionTypes.DistributionSupplierOrderOrderLines.UPDATE.SINGLE]({
    //     ...payload ,
    //     item:this.selectedSupplierOrderDetails
    //   });
    // },
    // onOrderLinesDelete:function(payload){

    // }
  },
};
</script>

<style lang="scss">
.cmp-distribution-supplier-order-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 149px);
  }
}
</style>


